export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILED = "FETCH_USER_DATA_FAILED";

export function fetchUserData() {
  return {
    type: FETCH_USER_DATA,
  };
}

export function fetchUserDataSuccess(payload) {
  return {
    type: FETCH_USER_DATA_SUCCESS,
    payload: payload,
  };
}

export function fetchUserDataFail(payload) {
  return {
    type: FETCH_USER_DATA_FAILED,
    payload: payload,
  };
}
